/* eslint-disable react/prop-types */
import React from 'react';
import ImageArea0 from './images/area/img_area_0.svg';
import ImageArea5 from './images/area/img_area_5.svg';
import ImageArea10 from './images/area/img_area_10.svg';
import ImageArea15 from './images/area/img_area_15.svg';
import ImageArea20 from './images/area/img_area_20.svg';
import ImageArea25 from './images/area/img_area_25.svg';
import ImageArea30 from './images/area/img_area_30.svg';
import ImageArea35 from './images/area/img_area_35.svg';
import ImageArea40 from './images/area/img_area_40.svg';
import ImageArea45 from './images/area/img_area_45.svg';
import ImageArea50 from './images/area/img_area_50.svg';
import ImageArea55 from './images/area/img_area_55.svg';
import ImageArea60 from './images/area/img_area_60.svg';
import ImageArea65 from './images/area/img_area_65.svg';
import ImageArea70 from './images/area/img_area_70.svg';
import ImageArea75 from './images/area/img_area_75.svg';
import ImageArea80 from './images/area/img_area_80.svg';
import ImageArea85 from './images/area/img_area_85.svg';
import ImageArea90 from './images/area/img_area_90.svg';
import ImageArea95 from './images/area/img_area_95.svg';
import ImageArea100 from './images/area/img_area_100.svg';
import ImageFee0 from './images/fee/img_fee_0.svg';
import ImageFee5 from './images/fee/img_fee_5.svg';
import ImageFee10 from './images/fee/img_fee_10.svg';
import ImageFee15 from './images/fee/img_fee_15.svg';
import ImageFee20 from './images/fee/img_fee_20.svg';
import ImageFee25 from './images/fee/img_fee_25.svg';
import ImageFee30 from './images/fee/img_fee_30.svg';
import ImageFee35 from './images/fee/img_fee_35.svg';
import ImageFee40 from './images/fee/img_fee_40.svg';
import ImageFee45 from './images/fee/img_fee_45.svg';
import ImageFee50 from './images/fee/img_fee_50.svg';
import ImageFee55 from './images/fee/img_fee_55.svg';
import ImageFee60 from './images/fee/img_fee_60.svg';
import ImageFee65 from './images/fee/img_fee_65.svg';
import ImageFee70 from './images/fee/img_fee_70.svg';
import ImageFee75 from './images/fee/img_fee_75.svg';
import ImageFee80 from './images/fee/img_fee_80.svg';
import ImageFee85 from './images/fee/img_fee_85.svg';
import ImageFee90 from './images/fee/img_fee_90.svg';
import ImageFee95 from './images/fee/img_fee_95.svg';
import ImageFee100 from './images/fee/img_fee_100.svg';

class ImageChart extends React.Component {
  render() {
    let chart;
    if (this.props.zogen >= 0) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea0}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee0}></img>;
      }
    } else if (0 > this.props.zogen && this.props.zogen >= -5) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea5}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee5}></img>;
      }
    } else if (-5 > this.props.zogen && this.props.zogen >= -10) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea10}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee10}></img>;
      }
    } else if (-10 > this.props.zogen && this.props.zogen >= -15) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea15}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee15}></img>;
      }
    } else if (-15 > this.props.zogen && this.props.zogen >= -20) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea20}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee20}></img>;
      }
    } else if (-20 > this.props.zogen && this.props.zogen >= -25) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea25}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee25}></img>;
      }
    } else if (-25 > this.props.zogen && this.props.zogen >= -30) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea30}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee30}></img>;
      }
    } else if (-30 > this.props.zogen && this.props.zogen >= -35) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea35}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee35}></img>;
      }
    } else if (-35 > this.props.zogen && this.props.zogen >= -40) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea40}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee40}></img>;
      }
    } else if (-40 > this.props.zogen && this.props.zogen >= -45) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea45}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee45}></img>;
      }
    } else if (-45 > this.props.zogen && this.props.zogen >= -50) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea50}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee50}></img>;
      }
    } else if (-50 > this.props.zogen && this.props.zogen >= -55) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea55}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee55}></img>;
      }
    } else if (-55 > this.props.zogen && this.props.zogen >= -60) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea60}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee60}></img>;
      }
    } else if (-60 > this.props.zogen && this.props.zogen >= -65) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea65}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee65}></img>;
      }
    } else if (-65 > this.props.zogen && this.props.zogen >= -70) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea70}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee70}></img>;
      }
    } else if (-70 > this.props.zogen && this.props.zogen >= -75) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea75}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee75}></img>;
      }
    } else if (-75 > this.props.zogen && this.props.zogen >= -80) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea80}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee80}></img>;
      }
    } else if (-80 > this.props.zogen && this.props.zogen >= -85) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea85}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee85}></img>;
      }
    } else if (-85 > this.props.zogen && this.props.zogen >= -90) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea90}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee90}></img>;
      }
    } else if (-90 > this.props.zogen && this.props.zogen >= -95) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea95}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee95}></img>;
      }
    } else if (-95 > this.props.zogen && this.props.zogen >= -100) {
      if (this.props.type == 'area') {
        chart = <img src={ImageArea100}></img>;
      } else if (this.props.type == 'fee') {
        chart = <img className="img_officeP" src={ImageFee100}></img>;
      }
    }
    return <div>{chart}</div>;
  }
}
export default ImageChart;
